// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3SnYm","inputWrap":"CustomTip_inputWrap__3RTbD"};